import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import BTLogo from "../assets/images/bt-logo.svg";
import { useAuth } from "./AuthContext";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `header-nav-link${isActive ? " active" : ""}`;

const Header: React.FC = () => {
  const { userInfo, hasBtCommunicationRole, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async (): Promise<void> => {
    await logout();
  };

  return (
    <div
      id="header-div"
      style={{
        justifyContent: userInfo ? 'space-between' : 'center'
      }}
    >
      <div className="d-flex align-items-center gap-3">
        <div id="header-div-logo" onClick={() => navigate("/dashboard")}>
          <button style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
            <img src={BTLogo} height={40} alt="Better Trucks Logo" />
          </button>
        </div>

        {userInfo && hasBtCommunicationRole && (
          <nav className="d-flex align-items-center gap-1" aria-label="Main">
            <NavLink to="/dashboard" className={navLinkClass}>
              <i className="bi bi-speedometer2"></i><span>Dashboard</span>
            </NavLink>
            <NavLink to="/companies" className={navLinkClass}>
              <i className="bi bi-building"></i><span>Companies</span>
            </NavLink>
          </nav>
        )}
      </div>

      {userInfo && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '0.25rem 0.75rem',
            background: 'rgba(255, 255, 255, 0.15)',
            borderRadius: '4px',
            color: '#fff'
          }}>
            <i className="bi bi-person-circle me-2" style={{ fontSize: '14px' }}></i>
            <span style={{ fontWeight: 500, fontSize: '14px' }}>
              {userInfo?.email || 'User'}
            </span>
          </div>
          <button
            onClick={handleLogout}
            className="btn btn-outline-light btn-sm"
            style={{ fontWeight: 600 }}
          >
            <i className="bi bi-box-arrow-right me-1"></i>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
